import { PostRequest } from "@services/http/BaseRequest";
import { UserRole } from "@services/http/responses/AccountResponse";
import useApiRequests from "@services/http/useApiRequest";
import { useMe } from "@utils/hooks/useMe";
import { Switch } from "antd";
import { useEffect, useState } from "react";
import Loader from "@components/global/Loader/Loader";
import { RecordResponse } from "@services/http/responses/BaseResponse";
import { useToasts } from "@utils/hooks/useToasts";
import { LoginData } from "@services/http/auth/dto";
import { useDispatch } from "react-redux";
import { RootDispatch } from "@store";
import AUTHSTATES from "@store/auth/AuthStates";
import { updateAuth } from "@store/auth/actions";
import { useIntl } from "react-intl";
import { useAuth } from "@utils/hooks/useAuth";
import styles from "./RoleSwitcher.module.scss";

type RoleToSwitch = "user" | "admin";

class SwitchRole extends PostRequest {
  constructor(role: RoleToSwitch) {
    super(`profile/switch?role=${role}`, {});
  }
}

export default function RoleSwitcher(): JSX.Element {

  //const me = useMe();
  const auth = useAuth();
  const dispatch = useDispatch() as RootDispatch;
  const [role, setRole] = useState<RoleToSwitch>("user");
  const requests = useApiRequests();
  const [isLoading, setIsLoading] = useState(false);
  const { error } = useToasts();
  const { formatMessage } = useIntl();

  useEffect(() => {
    //dbg.log("ROLE", me?.role);
    if (auth.role === UserRole.Admin) {
      setRole("admin");
    } else {
      setRole("user");
    }
  }, [auth.role]);

  // const doSwitchRole = async (role: RoleToSwitch) => {
  //   setIsLoading(true);    
  //   try {
  //     const result = await requests.enqueue<BaseResponse>(new SwitchRole(role));
  //     if (result && result.Status === "success") {
  //       setRole(role);
  //       window.location.reload();
  //     } else {
  //       error(result?.Message || "Unknown error");
  //     }
  //   } catch (error) {
  //     console.error("Failed to switch role:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  const doSwitchRole = async (role: RoleToSwitch) => {
    setIsLoading(true);
    try {
      const result = await requests.enqueue<RecordResponse<LoginData>>(new SwitchRole(role));
      if (result && result.Status === "success") {
        dispatch(
          updateAuth({
            id: result.Record.account?.Id ?? 0,
            state: AUTHSTATES.AUTHORIZED,
            email: {
              isPrivate: result.Record.account?.email?.is_private ?? true,
              value: result.Record.account?.email?.value ?? "",
            },
            isAdmin: role === "admin",
            role: role === "admin" ? UserRole.Admin : UserRole.User,
            uuid: result.Record.account?.uuid || "",
            name: result.Record.account?.name || "",
            controllerId: result.Record.account?.controller_id || "",
            m_online: result.Record.account?.m_online ?? 0,
            m_low: result.Record.account?.m_low ?? 0,
            m_offline: result.Record.account?.m_offline,
          })
        );
        //dbg.log("SETROLE", role);
        setRole(role);
        window.location.reload();
      } else {
        error(result?.Message || "Unknown error");
      }
    } catch (error) {
      console.error("Failed to switch role:", error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.roleSwitcher}>
      {isLoading && <Loader transparent={true} absolute={true} size={30} />}
      <div className={styles.caption}>
        {formatMessage({ id: "role_switcher.mode" })}
      </div>
      <label>
        {formatMessage({ id: "role_switcher.client" })}
      </label>
      <Switch
        disabled={isLoading}
        checked={role === "admin"}
        onChange={(checked) => {
          doSwitchRole(checked ? "admin" : "user")
        }}
      />
      <label>
        {formatMessage({ id: "role_switcher.hosting" })}
      </label>
    </div>
  );
}
